import React, {useEffect, useState} from "react";
import {IoMdArrowBack} from "react-icons/io";

import likeIco from "../../assets/icons/like.svg";
import disLikeIco from "../../assets/icons/dislike.svg";
import {useHistory, useParams, useRouteMatch} from "react-router-dom";
import {AiFillStar} from "react-icons/ai";
import {useSelector} from "react-redux";

export default function BlockTopicDetail() {

    const playListDataReducer = useSelector((state) => state.selectedContent.selectedContent);
    const {url} = useRouteMatch();
    const history = useHistory();
    const param = useParams()
    const topicID = param?.id;
    const [playlistData, _playlistData] = useState({});
    const [videoURL, _videoURL] = useState('');
    const [readMore, _readMore] = useState(false);
    let backURL = url.split("/");
    backURL.pop();
    backURL.pop();
    backURL = backURL.join("/");

    //url is used to redirect new Route
    const splitData = url.split('/')
    const newUrl = splitData.slice(0, 4).join('/');

    useEffect(() => {
        const oldURL = playListDataReducer?.url;
        const embedURL = oldURL.replace('watch?v=', 'embed/');
        _videoURL(embedURL);
        _playlistData(playListDataReducer);

    }, [playListDataReducer]);
    
    const goToPlayList = (id) => {
        history.push({
            pathname: `${newUrl}/playlists`,
            state: {contentId: id}
        });
    }
    return (
        <div className="pl-4 pr-2">
            <div className="flex items-center mb-4">
                <IoMdArrowBack size={25} className="cursor-pointer mr-5" onClick={() => history.push(`${backURL}`)}/>
                <h4 className="text-xl my-3">{playlistData?.channelTitle}</h4>
            </div>
            <iframe className="w-full aspect-video rounded-xl" src={videoURL}></iframe>
            <h5 className="text-sm mt-4 mb-2">{playlistData?.title}</h5>
            <div
                className={readMore ? 'readMore h-16 overflow-y-scroll' : 'h-14 overflow-ellipsis overflow-y-hidden'}>
                <p className="text-xs text-neutral-800">
                    {playlistData?.description}
                </p>
            </div>
            <p className="underline text-xs mt-2 text-right cursor-pointer"
               onClick={() => _readMore((prev) => !prev)}>Read
                {readMore ? ' Less' : " More"}</p>
            <div className="mt-4 mb-4 flex items-center gap-2">
                {playlistData?.stars ? Array.from({length: playlistData?.stars}, (_, index) => index + 1).map((item, index) =>
                    <span
                        key={index}><AiFillStar/>
                    </span>) : null}

            </div>
            <div className="flex items-center gap-x-4">
                <div>
                    <img src={likeIco} alt=""/>
                    <span className="text-xs">{playlistData?.likes}</span>
                </div>
                <div>
                    <img src={disLikeIco} alt=""/>
                    <span className="text-xs">5k</span>
                </div>
            </div>
            <div className="text-center">
                <button
                    onClick={() => goToPlayList(playlistData?.id)}
                    className="w-40  mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">Add
                </button>
            </div>
        </div>
    )
}
